var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-form',{ref:"form"},[_c('v-select',{staticClass:"group-solution-combo",attrs:{"id":"group-solution-select","item-text":"nome","item-name":"grupoSolucaoId","item-value":"grupoSolucaoId","items":_vm.gruopSolutions,"rules":_vm.rules,"disabled":_vm.disabled,"label":_vm.title
          ? _vm.title
          : _vm.isAT
          ? 'Grupos de Iniciativas'
          : _vm.isGov
          ? 'Grupos de fases'
          : 'Grupos de Soluções',"placeholder":_vm.title
          ? _vm.title
          : _vm.isAT
          ? 'Grupos de Iniciativas'
          : _vm.isGov
          ? 'Grupos de fases'
          : 'Grupos de Soluções',"clearable":""},on:{"change":function($event){return _vm.$emit('changeGroupSolution', _vm.grupoSolucaoIds)}},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [(_vm.mostrarTipo)?_c('div',{staticClass:"nomeTipo"},[(item.disabled)?_c('div',{staticClass:"tipo"},[_vm._v("Máximo de 5 eixos")]):(item.tipo)?_c('div',{staticClass:"tipo"},[_vm._v(_vm._s(item.tipo))]):_vm._e(),_c('div',[_vm._v(_vm._s(item.nome))])]):_c('span',[_vm._v(_vm._s(item.nome))])]}}]),model:{value:(_vm.grupoSolucaoIds),callback:function ($$v) {_vm.grupoSolucaoIds=$$v},expression:"grupoSolucaoIds"}},[_c('template',{slot:"no-data"},[_vm._v("\n        Nenhum\n        "+_vm._s(_vm.isAT
            ? "Grupo de Iniciativa"
            : _vm.isGov
            ? "Grupo de Fase"
            : "Grupo de Solução")+"\n        Retornado\n      ")])],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }